import SurveyViewModel from "./SurveyViewModel";

export default class SurveyDayRowViewModel {
    time: string = '';
    runningAccumulation: number = 0;
    arrivals: number | null = null;
    departures: number | null = null;
    vehicleOccupancyArrivals: number[] | null = null;
    vehicleOccupancyDepartures: number[] | null = null;
    hasBrackets: boolean = false;
    isVehicleOccupancy: boolean = false;
    survey: SurveyViewModel | null = null;
}
